import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Card, CardContent, CircularProgress, Alert, Button } from '@mui/material';
import { authService } from '../../services/authService';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('無効なリンクです');
      return;
    }

    authService.verifyEmail(token)
      .then((res) => {
        setStatus('success');
        setMessage(res.message);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'メール認証に失敗しました');
      });
  }, [searchParams]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="sm">
        <Card>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
              メールアドレス認証
            </Typography>

            {status === 'loading' && <CircularProgress />}
            {status === 'success' && (
              <>
                <Alert severity="success" sx={{ mb: 3 }}>{message}</Alert>
                <Button variant="contained" onClick={() => navigate('/auth/athlete-login')}>
                  ログインページへ
                </Button>
              </>
            )}
            {status === 'error' && (
              <>
                <Alert severity="error" sx={{ mb: 3 }}>{message}</Alert>
                <Button variant="outlined" onClick={() => navigate('/')}>
                  ホームに戻る
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default VerifyEmailPage;
